// Selectors
import { selectWorkTypesArray } from '../../services/workTypes/selectors';

// Utils
import orderBy from '../../utils/custom-orderBy';
import createDeepEqualSelector from '../../utils/reselect/createDeepEqualSelector';

interface Props {
    includeDeleted?: boolean;
    valueIsString?: boolean;
    useCompositeKey?: boolean;
}

const selectIncludeDeleted = (state: *, props: Props) => props.includeDeleted;
const selectValueIsString = (state: *, props: Props) => props.valueIsString;
const selectUseCompositeKey = (state: *, props: Props) => props.useCompositeKey;

const selectFilteredData = createDeepEqualSelector(
    [selectWorkTypesArray, selectIncludeDeleted],
    (workTypesArrayState, includeDeletedProp) => {
        if (includeDeletedProp) return workTypesArrayState;
        return workTypesArrayState.filter(value => !value.deletedAt);
    }
);

const selectOrderedData = createDeepEqualSelector(
    selectFilteredData,
    filteredDataState => orderBy(filteredDataState, ['name', 'id'])
);

const makeSelectOptions = () =>
    createDeepEqualSelector(
        [selectOrderedData, selectValueIsString, selectUseCompositeKey],
        (orderedDataState, valueIsStringProp, useCompositeKeyProp) =>
            orderedDataState &&
            orderedDataState.map(({ id, name, isPieceRate, entityTypeId }) => {
                if (valueIsStringProp) {
                    return {
                        key: id,
                        text: name,
                        value: `${id}`
                    };
                }
                if (useCompositeKeyProp) {
                    return {
                        key: id,
                        text: name,
                        value: `${id}.${isPieceRate}.${entityTypeId}`
                    };
                }
                return {
                    key: id,
                    text: name,
                    value: id
                };
            })
    );

export { selectFilteredData, selectOrderedData, makeSelectOptions };
